import { Link } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';
import { useAuthStore } from '../../stores/auth.store';

/**
 * The back link on the public legal pages (/privacy, /terms-of-use). A
 * signed-in reader came from their profile; a signed-out visitor has no
 * profile, so they go home ("/" sends a native app to login) (b-007).
 */
export function LegalBackLink() {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  return (
    <Link
      to={isAuthenticated ? '/app/profile' : '/'}
      className="inline-flex items-center gap-2 text-primary hover:text-primary-focus transition-colors"
    >
      <FiArrowLeft />
      <span>{isAuthenticated ? 'Back to Profile' : 'Back to Home'}</span>
    </Link>
  );
}
